import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core';

export const ReasonCaptureModal = ({ title, onCancel, onConfirm, minLength = 4 }) => {
  const [reason, setReason] = useState('');
  const disabled = reason.trim().length < minLength;

  return (
    <Dialog open onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          autoFocus
        />
        <p style={{ fontSize: 12, color: '#666' }}>
          This reason is recorded in the audit log and visible to Super-Admins and Owners.
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="primary" variant="contained" disabled={disabled} onClick={() => onConfirm(reason.trim())}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
